<template>
	<div class="template">
		<div class="table">
			<Table border :columns="diyData.columns" :data="apiData.tableList">
				<template slot="footer">
					<Page
						:total="apiData.total"
						show-total
						:page-size="apiData.per_page"
						:current="search.page"
						class-name="footer-page"
						@on-change="pageChange"
					></Page>
				</template>
			</Table>
		</div>
		<!-- 修改状态 -->
		<Modal v-model="diyDom.showModify" title="跟进">
			<Row>
				<span>状态：</span>
				<Select style="width: 400px" placeholder="请选择状态" v-model="form.status">
					<Option label="未跟进" value="0"></Option>
					<Option label="已跟进" value="1"></Option>
				</Select>
			</Row>
			<Row style="margin-top: 10px">
				<span>备注：</span>
				<Input style="width: 400px" type="textarea" v-model="form.remark" placeholder="请输入备注"></Input>
			</Row>
			<div slot="footer">
				<Button type="primary" @click="modifyModal">确认</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import { apiContactList, apiContactDelete, apiContactPut } from '@/api/contact'
	export default {
		name: 'contact',
		data() {
			return {
				query: {},
				search: {
					page: 1,
				},
				diyDom: {
					showModify: false,
				},
				form: {
					status: '0',
					remark: '',
				},
				diyData: {
					id: '',
					columns: [
						{
							title: 'ID',
							key: '',
							render: (h, params) => {
								return h('div', params.index + 1)
							},
						},
						{
							title: '机构名称',
							key: 'name',
						},
						{
							title: '联系电话',
							key: 'mobile',
						},
						{
							title: '来源公司',
							key: 'company',
						},
						{
							title: '来源教培机构',
							key: 'institution_name',
						},
						{
							title: '状态',
							render: (h, params) => {
								return h(
									'Tag',
									{
										props: {
											color: params.row.status == 1 ? 'success' : 'error',
										},
									},
									params.row.status_text
								)
							},
						},
						{
							title: '支持类型',
							key: 'type_text',
						},
						{
							title: '创建时间',
							key: 'created_at',
						},
						{
							title: '备注',
							key: 'remark',
						},
						{
							title: '操作',
							fixed: 'right',
							render: (h, params) => {
								return h('div', [
									h(
										'a',
										{
											style: {
												marginRight: '10px',
											},
											on: {
												click: () => {
													this.diyDom.showModify = true
													this.diyData.id = params.row.id
												},
											},
										},
										'跟进'
									),
									h(
										'a',
										{
											style: {
												color: '#ed4014',
											},
											on: {
												click: () => {
													this.$Modal.confirm({
														title: '提示',
														content: '请确认是否删除当前数据？',
														onOk: () => {
															apiContactDelete(params.row.id).then(() => {
																this.$Message.success('删除成功')
																this.getTableList()
															})
														},
													})
												},
											},
										},
										'删除'
									),
								])
							},
						},
					],
				},
				apiData: {
					total: 0,
					per_page: 0,
					tableList: [],
				},
			}
		},
		methods: {
			// 获取表格数据
			getTableList() {
				this.$store.commit('setSpinShow', true)
				apiContactList({ ...this.search })
					.then(res => {
						const { data, meta } = res
						this.apiData.tableList = data
						this.apiData.total = meta.pagination.total
						this.apiData.per_page = meta.pagination.per_page
					})
					.finally(() => this.$store.commit('setSpinShow', false))
			},
			// 分页
			pageChange(e) {
				this.search.page = e
				this.getTableList()
			},
			// 搜索
			searchFn() {
				this.search.page = 1
				this.getTableList()
			},
			// 清空
			clearFn() {},
			modifyModal() {
				apiContactPut(this.diyData.id, { ...this.form }).then(res => {
					this.$Message.success('跟进成功')
					this.diyDom.remark = ''
					this.diyDom.showModify = false
					this.getTableList()
				})
			},
		},
		mounted() {
			this.getTableList()
		},
	}
</script>

<style scoped lang="less">
	.template {
		.search {
			display: flex;
			justify-content: space-between;
		}
		.table {
			margin-top: 10px;
		}
		.filter {
			margin: 10px 0;
			display: flex;
			justify-content: left;
			align-items: center;
			padding: 6px 0 20px 0;
			flex-wrap: wrap;
			border: 1px solid rgba(237, 237, 237, 1);

			.filter-item {
				margin: 14px 0 0 20px;

				.title {
					margin-right: 10px;
					font-size: 12px;
					font-weight: 400;
					color: rgba(74, 74, 74, 1);
					line-height: 17px;
				}
			}
		}
	}
</style>
